import { nanoid } from 'nanoid';
import { Filter } from '@/containers/companies/types';

// Search and OrderBy are always present; the search box and sort control depend on them
export const createDefaultFilters = (): Filter<any>[] => [
    { id: nanoid(), operator: '', type: 'Search', value: '', criteria: '' },
    {
        id: nanoid(),
        operator: 'ascending',
        type: 'OrderBy',
        value: 'Created',
        criteria: '',
    },
];

export const hasDefaultFilters = (filters?: Filter<any>[]) =>
    Array.isArray(filters) &&
    filters.some((f) => f.type === 'Search') &&
    filters.some((f) => f.type === 'OrderBy');
